import VehiclePictureModal from './vehicle-picture-modal.vue'
export default VehiclePictureModal
